/*
 * The review screen. Register B, light ground — the console's own tokens.
 *
 * The layout is three columns per row because the FIELD is the unit of
 * deciding: item, quantity, unit price, each rendering as what it is, in the
 * column where its answer will go. A single-column layout would have been
 * easier and would have quietly collapsed the row to its least-resolved field.
 */
.page {
  padding: var(--space-4, 1rem);
  max-width: 72rem;
  margin: 0 auto;
}

.header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.line {
  margin-block: 1.25rem 0;
}

/* What the customer actually wrote. On an all-unmatched line it is the row. */
.rawText {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono, 0.75rem);
  color: var(--ink-soft);
  margin: 0 0 0.5rem;
}

.fields {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 1rem;
}

@media (max-width: 720px) {
  .fields {
    grid-template-columns: 1fr;
  }
}

.columnLabel {
  display: block;
  font-size: var(--text-min-mono, 0.75rem);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--muted);
}

.field {
  min-height: 2.5rem;
}

.resolved {
  color: var(--ink);
}

.evidence {
  font-size: var(--text-min-body, 0.875rem);
  color: var(--muted);
  margin: 0.15rem 0 0;
}

/* `LGH-036`, `PLT-081`. More than one candidate is a tie, named as one. */
.tieNotice {
  font-size: var(--text-min-mono, 0.75rem);
  color: var(--muted);
  margin: 0 0 0.35rem;
}

.question {
  color: var(--ink);
  margin: 0 0 0.4rem;
}

/*
 * Not an error colour. A field this console cannot read is a version skew, not
 * a fault in the quote, and the wording says so.
 */
.unreadable {
  font-size: var(--text-min-body, 0.875rem);
  color: var(--ink-soft);
  background: var(--paper-2);
  border-radius: var(--radius-soft);
  padding: 0.5rem;
  margin: 0;
}

.candidate {
  display: block;
  width: 100%;
  text-align: left;
  background: var(--card);
  border: 1px solid var(--paper-2);
  border-radius: var(--radius-soft);
  padding: 0.5rem;
  margin-bottom: 0.35rem;
  cursor: pointer;
}

.candidate:disabled {
  cursor: default;
  opacity: 0.6;
}

.candidateValue {
  display: block;
  color: var(--ink);
}

.freeText {
  display: flex;
  gap: 0.35rem;
  flex-wrap: wrap;
  align-items: center;
}

.freeText input {
  flex: 1 1 8rem;
  min-width: 0;
}

.conflict {
  border: 1px solid var(--stop);
  border-radius: var(--radius-soft);
  padding: 0.75rem;
  margin-block: 1rem;
}

.footer {
  margin-top: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.blocked {
  margin: 0;
  color: var(--muted);
  font-size: var(--text-min-body, 0.875rem);
}

.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
